const archives = ["executed", "archivecust", "archivecarrier", "archagreement"]; // Статусы которые попадают в общую группу архив

/*function randomInteger(min, max) {
  let rand = min + Math.random() * (max + 1 - min);
  return Math.floor(rand);
}*/

export const adjustRequestData = offer => {
  const status = offer.offerStatusId;
  const request = offer.requestId;
  const profile = request.profileId;
  const company = profile && profile.companyId;
  const requestType = request.requestTypeId;
  let newData = {
    id: offer.offerId,
    info: {
      offerNumber: offer.number,
      create: offer.createdAt,
      change: offer.updatedAt
    },
    view: {
      id:
        request && request.serviceTypeId && request.serviceTypeId.serviceTypeId,
      abbr:
        request &&
        request.serviceTypeId &&
        request.serviceTypeId.serviceTypeAbbr,
      key:
        request &&
        request.serviceTypeId &&
        request.serviceTypeId.serviceTypeKey,
      type:
        request && request.serviceTypeId && request.serviceTypeId.serviceType,
      color: "",
      description: ""
    },
    state: {
      status: status && status.offerStatus,
      statusKey: status && status.offerStatusKey,
      statusId: status && status.offerStatusId,
      statusKeyGroup: status && status.offerStatusKey,
      color: "",
      description: ""
    },
    requestType: {
      requestType: requestType && requestType.requestType,
      requestTypeId: requestType && requestType.requestTypeId,
      requestTypeKey: requestType && requestType.requestTypeKey
    },
    price: offer.price,
    totalPrice: offer.totalPrice,
    customer: {
      nameLegal: company && company.nameLegal ? company.nameLegal : null,
      subject:
        company && company.subjectId && company.subjectId.subject
          ? company.subjectId.subject
          : null,
      subjectAbbr:
        company && company.subjectId && company.subjectId.subjectAbbr
          ? company.subjectId.subjectAbbr
          : null,
      subjectId:
        company && company.subjectId && company.subjectId.subjectId
          ? company.subjectId.subjectId
          : null,
      subjectKey:
        company && company.subjectId && company.subjectId.subjectKey
          ? company.subjectId.subjectKey
          : null
    },
    routeLength: request.routes && request.routes.length,
    dateApplication: request.arrivalDatetime,
    placeDelivery: {
      city:
        request.routes && request.routes.length
          ? request.routes[0].route.split(",")[0]
          : "Не указано",
      address:
        request.routes && request.routes.length
          ? request.routes[0].route
              .split(",")
              .slice(1)
              .join(",")
          : ""
    },
    finalDestination: {
      city:
        request.routes && request.routes.length
          ? request.routes[request.routes.length - 1].route.split(",")[0]
          : "Не указано",
      address:
        request.routes && request.routes.length
          ? request.routes[request.routes.length - 1].route
              .split(",")
              .slice(1)
              .join(",")
          : ""
    },
    settlementForm: {
      id: request.paymentMethodId
        ? request.paymentMethodId.paymentMethodId
        : null,
      description: request.paymentMethodId
        ? request.paymentMethodId.paymentMethod
        : null
    },
    region: {
      id:
        request.routes && request.routes.length
          ? request.routes[0].regionId
          : ""
    },
    dayOfWeeks: {
      days:
        request.dayOfWeeks && request.dayOfWeeks.length > 0
          ? request.dayOfWeeks[0]
          : ""
    },
    watched: !!request.viewLog,
    driver: request.profileId && request.profileId.roleId === 6
  };
  if (request.routes && request.routes.length > 0) {
    newData.map = {
      id: offer.offerId,
      article: offer.number,
      dateApplication: request.arrivalDatetime,
      address: request.routes[0].route,
      latlng:
        request.routes[0].latitude && request.routes[0].longitude
          ? [+request.routes[0].latitude, +request.routes[0].longitude]
          : null
    };
  }
  if (archives.some(key => key === newData.state.statusKeyGroup)) {
    newData.state.statusKeyGroup = "archive";
  }
  let totalPassaengers = 0;
  totalPassaengers =
    ((!!request.passengersCount && parseInt(request.passengersCount)) || 0) +
    ((!!request.accompCount && parseInt(request.accompCount)) || 0) +
    ((!!request.kidsCount && parseInt(request.kidsCount)) || 0) +
    ((!!request.medWorkersCount && parseInt(request.medWorkersCount)) || 0) +
    ((!!request.workersCount && parseInt(request.workersCount)) || 0);
  newData.passengers = totalPassaengers;
  return newData;
};

export const dataAdjustmentGetAllOffersRequest = filters => {
  let newData = {};
  if (filters.page) {
    newData.page = filters.page;
  }

  if (filters.limit) {
    newData.perPage = filters.limit;
  }

  if (filters.type) {
    newData["status"] = filters.type;
  }

  if (filters.searchField) {
    newData.search_entry = filters.searchField;
  }

  if (filters.sort) {
    const { sort } = filters;
    if (sort.order) {
      newData[
        `sort[${sort.columnKey === "info" ? "number" : sort.columnKey}]`
      ] = sort.order === "ascend" ? "asc" : "desc";
    }
  }
  return newData;
};

export const dataAdjustmentFiltersRequest = filters => {
  const { search = false, fields = false } = filters;
  let newData = {};
  if (search) {
    newData.search_entry = search;
  }
  if (fields) {
    if (fields.serviceTypes) newData.service_type_key = fields.serviceTypes;
    if (fields.passengersMin)
      newData["passengers_count[from]"] = fields.passengersMin;
    if (fields.passengersMax)
      newData["passengers_count[to]"] = fields.passengersMax;
    if (fields.arrivalFrom)
      newData["arrival_datetime[from]"] = fields.arrivalFrom.format(
        "YYYY-MM-DD 00:00:00"
      );
    if (fields.arrivalTo)
      newData["arrival_datetime[to]"] = fields.arrivalTo.format(
        "YYYY-MM-DD 23:59:59"
      );
    if (fields.weekDays) newData.day_of_week_key = fields.weekDays;
  }
  return newData;
};
